import type { Course, CourseStatus } from './types';

export interface ScheduleStats {
  total: number;
  past: number;
  current: number;
  future: number;
}

export function getCourseStatus(startTime: string, endTime: string, now: Date): CourseStatus {
  if (new Date(endTime) <= now) return 'past';
  if (new Date(startTime) <= now) return 'current';
  return 'future';
}

export function getCoursesForRoom(courses: Course[], roomId: string): Course[] {
  return courses
    .filter((course) => course.roomId === roomId)
    .sort((first, second) => first.startTime.localeCompare(second.startTime));
}

export function getScheduleStats(courses: Course[], now: Date): ScheduleStats {
  return courses.reduce<ScheduleStats>(
    (stats, course) => {
      stats.total += 1;
      stats[getCourseStatus(course.startTime, course.endTime, now)] += 1;
      return stats;
    },
    { total: 0, past: 0, current: 0, future: 0 }
  );
}
